import { fetcher } from "@/api/api";
import type { IFActivityDetail } from "@/api/apiRsp/IFActivityList";

const popupActivityListRequest = {
  path: "api/activity/list",
  type: "post",
} as const;

const popupActivityListArgs = {
  needLogin: 1,
  showPosition: 1,
} as const;

const inflightRequests = new Map<object, Promise<IFActivityDetail[]>>();
const authScopes = new WeakMap<
  object,
  { token: string | null; scope: object }
>();

/** 登出后即使再次取得同一个 token，也不能复用上一轮尚未结束的请求。 */
export const getPopupActivityRequestScope = (
  owner: object,
  token: string | null
): object => {
  let current = authScopes.get(owner);
  if (!current || current.token !== token) {
    current = { token, scope: {} };
    authScopes.set(owner, current);
  }
  return current.scope;
};

/**
 * 供弹窗编排器复用的活动列表请求。
 * 只合并同一时段内的并发请求，请求结束后不做长期缓存，
 * 避免影响充值成功后的重新检查。
 */
export const fetchPopupActivityList = (
  authScope: object
): Promise<IFActivityDetail[]> => {
  const inflight = inflightRequests.get(authScope);
  if (inflight) return inflight;

  const request = fetcher<IFActivityDetail[]>(popupActivityListRequest, {
    arg: popupActivityListArgs,
  }).finally(() => {
    if (inflightRequests.get(authScope) === request) {
      inflightRequests.delete(authScope);
    }
  });
  inflightRequests.set(authScope, request);
  return request;
};
